angular.module('unica_campaign.campaign_controllers')

.controller('CampaignListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, $uibModal,
	CampaignListService, CampaignDeleteService, CampaignSendService
) {
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.campaignList = [];
	$scope.loadCampaigns = function()
	{
		$scope.showLoader();
		CampaignListService
			.list($scope.event_id)
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.campaignList = data;
				}
			});
	};

	$scope.loadCampaigns();


	$scope.deleteCampaign = function(campaignId)
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare la campagna?',
			text: 'Confermi la cancellazione della campagna?'
		}).then(function() {

			$scope.showLoader();

			CampaignDeleteService
				.delete( campaignId )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						angular.forEach($scope.campaignList, function(campaign, key) {
							if ( campaign.id === campaignId ) {
								$scope.campaignList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Campagna eliminata con successo!', '');
					}

				});

		}, function() {
			// Cancel
		});
	};

	$scope.sendCampaign = function(campaignId)
	{
		$confirm({
			title: 'Sei sicuro di voler inviare la campagna?',
			text: 'Confermi l\'invio della campagna?'
		}).then(function() {

			$scope.showLoader();

			CampaignSendService
				.send( campaignId )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						$scope.showSuccessMsg( data.sent + ' email inviate con successo!', '');

						$scope.loadCampaigns();
					}

				});

		}, function() {
			// Cancel
		});
	};


	$scope.openCampaignEmailsModal = function (eventId, campaignId)
	{
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalCampaignEmailsInstanceController',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/campaign-emails.html',
			size: 'lg',
			windowClass: 'modal-invitation-list',
			resolve: {
				campaignId: function () {
					return campaignId;
				},
				eventId: function() {
					return eventId;
				}
			}
		});
	};


})

.controller('ModalCampaignEmailsInstanceController',
	function ($scope, $uibModalInstance, eventId, campaignId, CampaignAssignService) {

		$scope.campaignEmails = [];

		$scope.loadCampaignEmails = function() {
			$scope.showLoader();

			CampaignAssignService
				.list( eventId, campaignId  )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						$scope.campaignEmails = data;
					}
				});
		};
		$scope.loadCampaignEmails();


		$scope.closeModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

	});